{
    "ModalTitleStatusChange": "Connexion de l'agent ACD",
    "LocationStatusTitle": "Localisation",
    "LocationStatusDescription": "Choisissez un dispositif et un agent ACD pour vous connecter.",
    "StatusOptionsTitle": "Options",
    "AcdGroupOptionsDescription": "Si le serveur téléphonique cible le supporte, vous pouvez choisir le groupe DAA pour lequel le statut DAA sélectionné sera spécifiquement modifié.",
    "AcdGroupLabel": "Groupe ACD",
    "AcdAgentLabel": "Agent ACD",
    "FooterButtonOk": "OK",
    "FooterButtonCancel": "Annuler",
    "FooterButtonHelp": "Aide",
    "StatusChange_PromptMessage": "Toutes les configurations seront perdues à la fermeture. Êtes-vous sûr de vouloir fermer cette fenêtre ?",
    "StatusChange_PromptConfirm": "Oui",
    "StatusChange_PromptCancel": "Annuler",
    "StatusChange_DevicesLabel": "Dispositif",
    "NAME": "StatusChange"
}